import React, { useEffect, useCallback, useMemo } from 'react';
import { searchPlanUwHistoryList } from '@store/actions/appListAction';
import { useDispatch, useSelector } from 'react-redux';

import { getDateByformat } from '@common/utils/date';

const SCROLL_TABLE_WRAP_ID = 'examinationProcessingHistoryWrap';

const ExaminationProcessingHistoryPopup = props => {
  const { policyNo } = props;
  const { planUwHistoryList = [] } = useSelector(state => state.appListReducer);
  const dispatch = useDispatch();

  useEffect(() => {
    handlerSearchList(policyNo);
  }, [policyNo]);

  //리스트 조회
  const handlerSearchList = useCallback(policyNo => {
    const searchPlanUwHistoryListCallback = () => {
      moveScrollBottom();
    };
    dispatch(
      searchPlanUwHistoryList({
        policyNo: policyNo,
        callback: searchPlanUwHistoryListCallback,
      }),
    );
  }, []);

  // scroll 하단 이동
  const moveScrollBottom = () => {
    const scrollWrapElement = document.getElementById(SCROLL_TABLE_WRAP_ID);
    scrollWrapElement.scrollTop = scrollWrapElement.scrollHeight;
  };

  // filter
  const getFilteredPlanUwHistoryList = useMemo(
    () =>
      planUwHistoryList.filter(
        item =>
          !['심사자의견', '메모전달', '신계약 이관 사유'].includes(
            item?.historyStep,
          ),
      ),
    [planUwHistoryList],
  );

  // 현재 진행상황 인지 구분
  const isProceeding = (index, lastIndex, item) => {
    return !item?.processDate && index === lastIndex;
  };

  return (
    <>
      <header className="modal-header">
        <h3 className="layer-tit2">처리 이력</h3>
      </header>
      <div className="cont">
        <div className="modal-scroll-wrap" id={SCROLL_TABLE_WRAP_ID}>
          <table className="tbl-sty1 list-type">
            <colgroup>
              <col style={{ width: '20%' }} />
              <col style={{ width: '9.8rem' }} />
              <col />
              <col style={{ width: '7.1rem' }} />
            </colgroup>
            <thead>
              <tr>
                <th>처리 일자</th>
                <th>단계</th>
                <th>처리 구분</th>
                <th>처리자</th>
              </tr>
            </thead>
            <tbody>
              {getFilteredPlanUwHistoryList.length > 0 ? (
                getFilteredPlanUwHistoryList.map((item, index) => {
                  return (
                    <tr key={index}>
                      <td>
                        <span className="f-12 bold">
                          {getDateByformat(item?.processDate)}
                        </span>
                      </td>
                      <td>
                        <span className="f-12 bold">
                          {item?.historyStep ?? ''}
                        </span>
                      </td>
                      <td className="text-left">
                        {item?.processDescription ?? ''}
                      </td>
                      <td>
                        <span className="f-12 bold">
                          {item?.prcocessor ?? ''}
                        </span>
                      </td>
                    </tr>
                  );
                })
              ) : (
                <tr>
                  <td colSpan={4} className="nodata">
                    {'검색된 결과가 없습니다.'}
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
};

export default ExaminationProcessingHistoryPopup;
